import trfdoc from '../../../static/trf-doc.svg';
import multiplecollection from '../../../static/multiple-collection.svg';
import recollection from '../../../static/recollection.svg';

const TRF_TYPES = {
  REGULAR_COLLECTION: 'REGULAR COLLECTION',
  RECOLLECTION: 'RECOLLECTION',
  MULTIPLE_COLLECTION: 'MULTIPLE COLLECTION',
  DIGITAL_TRF: 'DIGITAL TRF COLLECTION',
};

function returnIconBasedOnType(type) {
  if (type === 'REGULAR COLLECTION' || type === TRF_TYPES.DIGITAL_TRF) {
    return trfdoc;
  }
  if (type === 'RECOLLECTION') {
    return recollection;
  }
  if (type === 'MULTIPLE COLLECTION') {
    return multiplecollection;
  }
}

function filterDuplicates(array) {
  const val = array.concat();
  for (let i = 0; i < val.length; i += 1) {
    for (let j = i + 1; j < val.length;) {
      if (val[i] === val[j]) {
        val.splice(j, 1);
      } else {
        j += 1;
      }
    }
  }

  return val;
}

export { returnIconBasedOnType, TRF_TYPES, filterDuplicates };
